import { combineReducers } from 'redux'
import { IFilterState } from '../../types'
import { PROVIDER_FILTER } from '../constants'
import { assistanceCategories, assistances, assistanceSearch } from './assistance'
import { authorization } from './auth'
import { drivers } from './drivers'
import { errors } from './errors'
import { success } from './success'
import { integrations } from './integrations'
import { globalSettings } from './global-settings'
import { mapView } from './google_map'
import { locations } from './locations'
import { membership } from './membership_request'
import { mobilityOptions, mobilityOptionsCategories, mobilityOptionsSearch } from './mobility-options'
import { organizations } from './organizations'
import { organizationsBankAccounts } from './organizations/bank-account'
import { programService } from './program_services'
import { providerProduct } from './provider-products/index'
import { riders, riderSearch } from './riders'
import { riderLocations } from './rider-location'
import { service } from './services'
import { serviceEdit } from './services/edit'
import { servicePricing } from './services/servicePricing'
import { serviceProgram } from './service-program/service-program'
import { teamMember } from './team_members'
import { stationUser } from './station-user'
import { stationUserGoinzones } from './station-user-goin-zones'
import { trips, tripsHistory } from './trips'
import { tripMenuService } from './trip-menu-services'
import { tripRequest } from './trips/request'
import user from './users'
import { vehicles } from './vehicles'
import { goinzones } from './goinzones'
import { organizationLegalEntity } from './organizations/legal-entity'
import { vehicleCreateOptions } from './vehicles/vehicle-create-options'
import { organizationPromotions } from './organizations/promotions'
import { subscriptionPlans } from './subscriptions'
import { stationUserTrips } from './station-user-trips'
import { teamMemberPermission } from './team-member-permission'
// RIDER PORTAL REDUCERS
import { riderPortal } from './rider-portal'
function filters(state: IFilterState = {}, action: any): IFilterState {
  switch (action.type) {
    case PROVIDER_FILTER:
      return Object.assign({}, state, {
        provider: action.query
      })
  }
  return state
}

const rootReducer = combineReducers({
  assistanceCategories,
  assistanceSearch,
  assistances,
  authorization,
  drivers,
  errors,
  success,
  filters,
  globalSettings,
  integrations,
  locations,
  mapView,
  membership,
  mobilityOptions,
  mobilityOptionsCategories,
  mobilityOptionsSearch,
  organizations,
  organizationsBankAccounts,
  organizationLegalEntity,
  organizationPromotions,
  programService,
  goinzones,
  providerProduct,
  riderLocations,
  riderPortal,
  riderSearch,
  riders,
  service,
  serviceEdit,
  servicePricing,
  serviceProgram,
  stationUser,
  stationUserGoinzones,
  teamMember,
  tripRequest,
  trips,
  tripMenuService,
  tripsHistory,
  user,
  vehicles,
  vehicleCreateOptions,
  subscriptionPlans,
  stationUserTrips,
  teamMemberPermission
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/state/reducers/index.ts